import { useEffect, useState } from 'react'
import { hubspotTrackingCookie } from '../utils/marketingAnalytics'

const POLL_MS = 500
const GIVE_UP_MS = 30_000

/**
 * The HubSpot tracking cookie (hutk), re-read until it appears. The HubSpot tracker sets it
 * some time after the page renders, and the form's hidden `hutk` input must show it once it
 * exists (marketing checks the inputs in the inspector), so the page re-renders when it lands.
 */
export function useHubSpotTrackingCookie(): string | undefined {
  const [value, setValue] = useState<string | undefined>(() => hubspotTrackingCookie())

  useEffect(() => {
    if (value) return
    const giveUp = Date.now() + GIVE_UP_MS
    const timer = window.setInterval(() => {
      const cookie = hubspotTrackingCookie()
      if (cookie) {
        setValue(cookie)
        window.clearInterval(timer)
      } else if (Date.now() > giveUp) {
        window.clearInterval(timer)
      }
    }, POLL_MS)
    return () => window.clearInterval(timer)
  }, [value])

  return value
}
